module.exports = __webpack_public_path__ + "static/img/title_04.8d2be979.png";